export type AdminType =
  | 'sysAdmin'
  | 'orgAdmin'
  | 'orgBearerManager'
  | 'orgReader'
  | 'deptAdmin'
  | 'deptBearerManager'
  | 'deptReader'
  | 'deptUser';

export interface RoleIds {
  sysAdmin: string;
  orgAdminWrite: string;
  orgBearerManager?: string;
  orgAdminRead: string;
  deptUser: string;
}

export const getAdminTypePriority = (
  roleIds: RoleIds,
  role_id: string,
): number => {
  switch (role_id) {
    case roleIds.sysAdmin:
      return 10;
    case roleIds.orgAdminWrite:
      return 9;
    case roleIds.orgBearerManager:
      return 8;
    case roleIds.orgAdminRead:
      return 7;
    default:
      return 0;
  }
};

export const isOrganizationRole = (roleIds: RoleIds, role_id: string) =>
  role_id === roleIds.orgAdminWrite ||
  role_id === roleIds.orgBearerManager ||
  role_id === roleIds.orgAdminRead;

export const adminTypeColor: Record<AdminType, string> = {
  sysAdmin: 'bg-orange-500 text-contrast-yellow',
  orgAdmin: 'bg-green-600 text-contrast-green',
  orgBearerManager: 'bg-green-500 text-contrast-green',
  orgReader: 'bg-green-400 text-contrast-green',
  deptAdmin: 'bg-blue-500 text-contrast-blue',
  deptBearerManager: 'bg-blue-300 text-contrast-blue',
  deptReader: 'bg-blue-400 text-contrast-blue',
  deptUser: 'bg-background-400 text-text-900',
};
